import Images from './images'
export default Images
